import type { DirVendorType } from '@econtractor/types';
import type { VendorOption } from './types';

export const toVendorOptions = (vendors: DirVendorType[] | undefined | null): VendorOption[] =>
    (vendors || []).map((v) => ({
        value: String(v.ID),
        label: String(v.vendorName || `#${v.ID}`),
    }));
